import { Box, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { BentoBrand } from "schemas/dashboard";

import styles from "../styles";

interface Props {
  brand: BentoBrand;
}

const BrandLogo = ({ brand }: Props) => {
  return (
    <Box sx={styles.logoContainer}>
      <Box sx={styles.logo}>
        {brand.logoUrl ? (
          <Box
            component="img"
            src={brand.logoUrl}
            alt={`${brand.brandName} logo`}
            onError={(e: any) => {
              e.target.onerror = null;
              e.target.style.display = "none";
            }}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        ) : null}

        {!brand.logoUrl && (
          <Typography variant="h3" sx={{ color: grey[600], fontWeight: 700 }}>
            {brand.brandName?.[0]?.toUpperCase() || "?"}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default BrandLogo;
